import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Card, CardContent, CardHeader, CardTitle } from "Components/ui/card";
import { ShoppingCart, PackageCheck, Loader, Truck, CheckCircle, XCircle, Undo2 } from "lucide-react";

// One row per stage of the path, then the exits, in the order an order moves
// (ops decision 2026-10-21). The keys are the counts endpoint's names, which
// outlive renames: "ready_order" is Handed to shipping company. Earlier this
// panel labelled Confirmed as "Processing", which is now a stage of its own.
const STATUS_ROWS = [
  { key: "order_placed", label: "New Orders", icon: ShoppingCart, color: "#4B7A8E", path: "/order/placed" },
  { key: "order_confirmed", label: "Confirmed", icon: PackageCheck, color: "#D4A017", path: "/order/confirmed" },
  { key: "processing", label: "Under processing", icon: Loader, color: "#8A6508", path: "/order/processing" },
  { key: "ready_order", label: "Handed to shipping company", icon: Truck, color: "#5B8DEF", path: "/order/ready" },
  { key: "delivered", label: "Delivered", icon: CheckCircle, color: "#2E7D5B", path: "/order/delivered" },
  { key: "cancelled", label: "Cancelled", icon: XCircle, color: "#D14343", path: "/order/cancelled" },
  { key: "returned", label: "Returned", icon: Undo2, color: "#B23A32", path: "/order/returned" },
];

export default function OrderStatusPanel() {
  const navigate = useNavigate();
  const headerCount = useSelector((state) => state?.bookingSlice?.getHeaderCount);

  const total = STATUS_ROWS.reduce((sum, row) => sum + (headerCount?.[row.key] || 0), 0);

  return (
    <Card>
      <CardHeader>
        <CardTitle style={{ fontSize: "16px" }}>Live Orders</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        {STATUS_ROWS.map(({ key, label, icon: Icon, color, path }) => {
          const count = headerCount?.[key] || 0;
          const percentage = total > 0 ? (count / total) * 100 : 0;
          const isNew = key === "order_placed";

          return (
            <div
              key={key}
              onClick={() => navigate(path)}
              style={{
                display: "flex", alignItems: "center", gap: "12px",
                padding: "12px 16px", cursor: "pointer",
                background: isNew ? "rgba(75,122,142,0.06)" : "transparent",
                borderBottom: "1px solid #EAEFEF",
                transition: "background 200ms",
              }}
              onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(75,122,142,0.06)"; }}
              onMouseLeave={(e) => { e.currentTarget.style.background = isNew ? "rgba(75,122,142,0.06)" : "transparent"; }}
            >
              <Icon size={18} color={color} />
              <span style={{ flex: 1, fontFamily: "tt-regular", fontSize: "14px", color: "#25343F" }}>
                {label}
              </span>
              <span style={{ fontFamily: "Aenoik-medium", fontSize: "16px", color: "#25343F", minWidth: "32px", textAlign: "right" }}>
                {count}
              </span>
              <div style={{ width: "60px", height: "6px", background: "#EAEFEF", borderRadius: "3px", overflow: "hidden" }}>
                <div style={{ width: `${percentage}%`, height: "100%", background: color, borderRadius: "3px", transition: "width 300ms ease" }} />
              </div>
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
}
